export const skuGeneration =  [
    {
      id: "1",
      label: "Generate by sequence number",
      isDisable : false,
    }
    ,
    {
      id: "2",
      label: "Generate by name",
      isDisable : true
    },
  ];